import { useState, useEffect, useRef } from 'react';

const useScrollPosition = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const ticking = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset;

      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          setScrollPosition(position);
          ticking.current = false;
        });
        ticking.current = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return { scrollPosition };
};

export default useScrollPosition;